import React from 'react';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppLocationsService from '../AppLocationsService';

//global component
import ModalButton from '../../../shared/Buttons/ModalButton';

//hooks
import { useRouter } from '../../../shared/hooks/useRouter';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
} from '../../../SharedStyles';

const RedirectMeter = (props) => {
  const { strings } = AppLocationsService;
  const { handleCloseModal, loc } = props;
  const router = useRouter();

  const closeModal = () => {
    handleCloseModal();
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    router.history.push(`/meter-groups?locationId=${loc.id}`);
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.meterGroupTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <p>{strings.meterGroupContent}</p>
          </ModalItemStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          handleClick={handleSaveInfo}
          buttonText={strings.go}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default RedirectMeter;
